import { useSelector } from 'react-redux';
import {
    getCampaignsForLeavingSoon,
    getCategoryTabId,
    getTabs,
} from '@client/redux/modules/mylounge';
import { CategoryTabIds } from '@shared/constants';
import { enrichWithLeavingSoonFlag } from '../helpers';
import { UseLeavingSoonDataReturn } from '../types';

/**
 * Hook for fetching and filtering leaving soon campaign data
 * Handles Redux selectors and campaign filtering (removes THB)
 *
 * @returns {UseLeavingSoonDataReturn} Filtered campaigns and current category tab ID
 */
export const useLeavingSoonData = (isLeavingSoonLabel?: boolean): UseLeavingSoonDataReturn => {
    const categoryTabId = useSelector(getCategoryTabId);
    const tabs = useSelector(getTabs);
    // Filter out "All Campaigns" THB campaign
    const allCampaignsThbCampaignId = tabs?.find(tab => tab.id === CategoryTabIds.ALL)?.thb?.id;

    const allLeavingSoonCampaigns = useSelector(getCampaignsForLeavingSoon) || [];

    const leavingSoonCampaignsWithoutTHBCampaign = allLeavingSoonCampaigns.filter(
        campaign => campaign.campaignId !== allCampaignsThbCampaignId,
    );

    const leavingSoonCampaigns = isLeavingSoonLabel
        ? enrichWithLeavingSoonFlag(leavingSoonCampaignsWithoutTHBCampaign)
        : leavingSoonCampaignsWithoutTHBCampaign;

    return {
        leavingSoonCampaigns,
        categoryTabId,
    };
};
